module.exports = __webpack_public_path__ + "static/favicon-1566518732621585fa7f203e387a7505.ico";